export default __webpack_public_path__ + "static/media/logo_frecciabianca.aa1c7151.svg";